<mat-toolbar color="accent">Edit Media Tags</mat-toolbar>
<div class="layout-padding">
  <pr-tags-input
    [tagCol]="tagsCol$ | async"
    [formControl]="tagsCtrl"
    [tagType]="tagType"
  />
  <pt-buttons-container>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!tagsCtrl.valid"
      (click)="dialogRef.close(tagsCtrl.value)"
    >
      Update Tags
    </button>
  </pt-buttons-container>
</div>
